export default {
  state: {
    isSaving: false
  },
  mutations: {
    setSaving (state, isSaving) {
      state.isSaving = isSaving
    }
  }
}